<template>
  <ion-content style="--background: black;">
    <div style="z-index: 9999; width:100%; height: 64px; position: fixed; top:15px; display: inline-block;">
      <div style="float:right; margin-right:10px; cursor: pointer;" @click="closeModal"><ion-icon
       style="font-size:36px; color: white;" :icon="closeCircle"></ion-icon></div>
    </div>  
    <div class="centered-image">
      <swiper-container style="height:100vh;" :zoom="true">
        <swiper-slide>
          <div class="swiper-zoom-container">
            <img :style="'height:' + height + 'width:' + width" :src="image">
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div v-if="image_id!=0" style="z-index: 9999; width:100%; height: 64px; position: fixed; bottom:15px; display: inline-block;">
       <div style="float:left; margin-left:10px; cursor: pointer;" @click="openLink(image)">
        <ion-icon
       style="font-size:36px; color: white;" :icon="download"></ion-icon></div>
    </div>  
    
  </ion-content>
</template>

<script>
import {  modalController, IonIcon, IonContent, loadingController, isPlatform } from '@ionic/vue';
import { closeOutline, closeCircle, download  } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { Browser } from '@capacitor/browser';

export default defineComponent({
  name: 'PhotoView',
  props: {
    image_id: { type: Number, default: 0 },
    image: { type: String, default: '' },
    width: { type: String, default: '100%' },
    height: { type: String, default: '100%' },
  },
  components: {
    IonIcon,
    IonContent
  },
  setup() {
    const isDisabled = false;
    const closeModal = () => {
      modalController.dismiss();
    };
    return {
      closeOutline,
      closeModal,
      isDisabled,
      closeCircle,
      download
    }
  },
  data(){
    return{
      loadingIndicator: null
    }
  },
  methods:{
    async presentLoading(message) {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: message,
        });
      await this.loadingIndicator.present();
    },
    async openLink(link_url) {
      if (link_url != '') {
        if (isPlatform('hybrid') || isPlatform('electron')) {
          await Browser.open({ url: link_url, presentationStyle: 'popover' });
        }else{
          window.open(link_url, '_blank');
        }
      }
    },
    async downloadData(){
      await this.presentLoading(this.$t('loadmessage.loading'));
        
      let response = await this.$store.dispatch("helpers/downloadImage", {
        id: this.image_id
      });
      if(response!=undefined){
        if(response.error!=undefined){
          console.log('error: ' + response.error);
          this.loadingIndicator.dismiss();
        }else{
          let image_title = Date.now();
          this.forceFileDownload(response, 'image_'+image_title+'.jpg');
        }
      }
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loadingIndicator.dismiss();
    },

  }
});
</script>
<style>
.centered-image {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

</style>
